import api from "@/lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Upload once, then poll the background analysis until done/failed. onUpdate receives each status snapshot.
export async function runKnowledgeAnalysis(file, onUpdate, existingId) {
  let a;
  if (existingId) {
    a = (await api.post(`/knowledge/analyses/${existingId}/retry`)).data;
  } else {
    const fd = new FormData();
    fd.append("file", file);
    a = (await api.post("/knowledge/analyses", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
  }
  onUpdate?.(a);
  for (let i = 0; a.status === "processing" && i < 240; i++) {
    await wait(1500);
    try { a = (await api.get(`/knowledge/analyses/${a.id}`)).data; onUpdate?.(a); } catch (e) { if (i > 5) throw e; }
  }
  return a;
}

export const SUGGEST_MAP = {
  title: "title", display_title: "display_title", description: "description", topic: "topic", publisher: "publisher",
  category: "category", document_type: "document_type", document_number: "document_number", issue_date: "issue_date",
  date_kind: "date_kind", effective_date: "effective_date", document_year: "document_year", applicability_mode: "applicability_mode",
  applicable_states: "applicable_states", bulletin_number: "bulletin_number", file_name: "canonical_filename",
};

// Fill only fields the user hasn't edited; never overwrite their changes on re-analysis.
export function applySuggestions(form, sug, touched) {
  const next = { ...form };
  Object.entries(SUGGEST_MAP).forEach(([s, f]) => {
    const v = sug?.[s];
    if (touched.has(f) || v === null || v === undefined || v === "" || (Array.isArray(v) && !v.length && f !== "applicable_states")) return;
    next[f] = typeof v === "number" ? String(v) : v;
  });
  return next;
}
